import { Component, Input } from '@angular/core'
import { Store } from '@ngrx/store'
import { ScopeVersion } from '@app/core/model/scope-version'
import { ChangeRequest } from '@app/core/model/change-request.model'
import { CdnConfig } from '@app/core/model/cdn-config.model'
import { ChangeRequestSelectors } from '../../store/selectors/change-request.selectors'
import { combineLatest, map } from 'rxjs'
@Component({
  selector: 'change-request-list',
  templateUrl: './change-request-list.component.html',
  styleUrls: ['./change-request-list.component.scss'],
})
export class ChangeRequestListComponent {
  @Input() currentScope: ScopeVersion
  @Input() currentChangeRequest: ChangeRequest
  @Input() cdnConfig: CdnConfig

  @Input() mainColumnClass: string
  @Input() componentMainColumnClass: string
  @Input() roleMainColumnClass: string

  netChanges$ = combineLatest([
    this.store$.select(ChangeRequestSelectors.selectNetChangesUnsectionedDeliverables),
    this.store$.select(ChangeRequestSelectors.selectNetChangesSections),
  ]).pipe(map(([deliverables, sections]) => ({ deliverables, sections })))

  constructor(private store$: Store) {}
}
